<template>
<!-- Navbar -->
<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <!-- Container wrapper -->
  <div class="container-fluid">
    <!-- Toggle button -->
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
      style="border:1px solid #666;"
    >
      <van-icon name="ellipsis" size="24" color="#111" />
    </button>
    <p class="mobile-title">
      <img
          src="@/assets/3fish_rect.png"
          width="100"
          height="50"
          alt="3fisherspecial Logo"
          loading="lazy"
        />
    </p>

    <!-- Collapsible wrapper -->
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <!-- Navbar brand -->
      <a class="navbar-brand mt-2 mt-lg-0" href="#">
        <img
          src="@/assets/3fish_rect.png"
          width="100"
          height="50"
          alt="3fisherspecial Logo"
          loading="lazy"
        />
      </a>
      <!-- Left links -->
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item"  @click="collapseNav()">
          <router-link class="nav-link" to="/">首页</router-link>
        </li>
        <li class="nav-item dropdown">
          <a
            class="nav-link dropdown-toggle"
            href="#"
            id="navbarDropdownMenuLink"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            产品分类
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
            <li  @click="collapseNav()">
              <router-link class="nav-link" to="/Category">御燕玺礼 燕窝</router-link>
            </li>
            <li @click="collapseNav()">
              <router-link class="nav-link" to="/Category/Wagyu">常陆牛5A和牛</router-link>
            </li>
          </ul>
        </li>
        <li class="nav-item" @click="collapseNav()">
          <router-link class="nav-link" to="/Gallery">相册</router-link>
        </li>
        <li class="nav-item" @click="collapseNav()">
          <router-link class="nav-link" to="/About">关于我们</router-link>
        </li>
      </ul>
      <!-- Left links -->
    </div>
    <!-- Collapsible wrapper -->

    <!-- Right elements -->
    <div class="d-flex align-items-center">
      <!-- Icon -->
      <router-link class="text-reset me-3" style="margin-top:5px;" to="/Shopping">
        <van-icon name="cart-o" size="25" color="#1989fa" />
      </router-link>
     
      <!-- Avatar ->
      <div class="dropdown">
        <a
          class="dropdown-toggle d-flex align-items-center hidden-arrow"
          href="#"
          id="navbarDropdownMenuAvatar"
          role="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <van-icon name="user-circle-o" size="24" color="#333333" />
        </a>
        <ul
          class="dropdown-menu dropdown-menu-end"
          aria-labelledby="navbarDropdownMenuAvatar"
        >
          <li>
            <a class="dropdown-item" href="#">My profile</a>
          </li>
          <li>
            <a class="dropdown-item" href="#">Settings</a>
          </li>
          <li>
            <a class="dropdown-item" href="#">Logout</a>
          </li>
        </ul>
      </div>
      -->
    </div>
    <!-- Right elements -->
  </div>
  <!-- Container wrapper -->
</nav>
</template>
<script>
  import { onMounted } from 'vue'
  import $ from 'jquery'
  //import $ from 'jquery'
  export default {
    name: 'Nav',
    setup() {
        onMounted(() =>{
            console.log('Nav component mounted')
            
        })
        const collapseNav = () => {
          $('#navbarSupportedContent').removeClass('show')
        }
        return {
          collapseNav
        }
    }
  };
</script>
<style lang="scss" scoped>
  nav {
    margin-top: 0px;
    margin-bottom: 1px;
    padding-top: 2px;
    padding-bottom: 5px;
    background: url(../assets/navbk.png) no-repeat center center; 
    background-size: 100% 100%;
    a {
      font-weight: bold;
      color: #2c3e50;
      &.router-link-exact-active {
        color: #d88d00;
      }
    }
    .mobile-title {
      margin-top: 10px;
    }
    @media only screen and (min-width: 1200px) {
      .mobile-title {display:none;}
    }
    @media only screen and (max-width: 500px) {
      .nav-link {padding-left: 5px;padding-right:5px;}
    }
  }

</style>